var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-drawer',{attrs:{"name":"chats-filter"}},[_c('v-list',{class:_vm.$style.list,attrs:{"list":_vm.menu,"checkedName":_vm.chatsName},on:{"click":function($event){return _vm.onMenu($event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }